import { TxInIcon, TxOutIcon, TxBonusIcon } from "./icons";

const TX_ICONS = {
  in: TxInIcon,
  out: TxOutIcon,
  bon: TxBonusIcon,
};

export default function TxRow({ row }) {
  const Icon = TX_ICONS[row.type] || TxInIcon;
  return (
    <div className="txrow">
      <span className={`tx-ic ${row.type}`}>
        <Icon />
      </span>
      <div className="tx-t">
        <b>{row.title}</b>
        <small>{row.when}</small>
      </div>
      <div style={{ textAlign: "right" }}>
        <div className={`tx-v ${row.vClass}`}>{row.value}</div>
        <span className={`tx-s ${row.sClass}`}>{row.status}</span>
      </div>
    </div>
  );
}
